import { css } from '@emotion/core';
import { media, tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var miniBold = designTokenFonts.miniBold,
  mini = designTokenFonts.mini;
var colours = tokens.colors;
export var nextEvent = /*#__PURE__*/css("display:block;text-align:left;background-color:", colours.neutral.subdued.default, ";border-radius:2px;padding-left:11px;padding-top:3px;padding-bottom:6px;", media('>=tablet'), "{margin-bottom:17px;}");
export var heading = /*#__PURE__*/css("display:inline-block;", miniBold, ";color:", colours.neutral.heavy.default, ";margin-right:3px;");
export var body = {
  name: "1baulvz",
  styles: "display:inline-block;"
};
export var inspection = {
  name: "1baulvz",
  styles: "display:inline-block;"
};
export var buttons = {
  name: "11zpol9",
  styles: "float:right;padding-right:18px;"
};
export var item = /*#__PURE__*/css(mini, ";");
export var itemLeft = /*#__PURE__*/css("display:inline-block;color:", colours.neutral.heavy.default, ";text-decoration:none;padding-top:3px;");
export var itemTime = {
  name: "1vabjgz",
  styles: "display:inline-block;margin-right:10px;margin-left:3px;"
};
export var itemButton = /*#__PURE__*/css("color:", colours.neutral.heavy.default, ";padding:0;border:0;outline:none;background:none;vertical-align:top;float:right;cursor:pointer;");